import { useState } from "react";
import ConfirmationAlert from "./ConfirmationAlert";
import SuccessIcon from "../Components/Icons/SuccessIcon";
import RejectedIcon from "../Components/Icons/RejectedIcon";
import InfoIcon from "../Components/Icons/InfoIcon";

const ICON_BY_TYPE = {
  success: SuccessIcon,
  error: RejectedIcon,
  info: InfoIcon,
};

const TITLE_BY_TYPE = {
  success: "Success",
  error: "Error",
  info: "Info",
};

// Partners-module replacement for toast notifications: renders a single
// modal (via ConfirmationAlert) that stays open until the user clicks OK.
export default function useAlertModal() {
  const [alert, setAlert] = useState({ open: false, type: "info", title: "", message: "" });

  function close() {
    setAlert((prev) => ({ ...prev, open: false }));
  }

  function show(type, message, title) {
    setAlert({ open: true, type, message, title: title || TITLE_BY_TYPE[type] });
  }

  const showSuccess = (message, title) => show("success", message, title);
  const showError = (message, title) => show("error", message, title);
  const showInfo = (message, title) => show("info", message, title);

  const Icon = ICON_BY_TYPE[alert.type];

  const AlertModal = (
    <ConfirmationAlert
      open={alert.open}
      close={close}
      icon={<Icon width={"4.8rem"} height={"4.8rem"} />}
      title={alert.title}
      subTitle={alert.message}
      confirm={close}
      returnRespButton={"OK"}
    />
  );

  return { showSuccess, showError, showInfo, AlertModal };
}
